import type { MetaDataOptions } from '.';

export const populateVariables = (
  text: string,
  variables: Record<string, any>
): string => {
  if (!text || !variables) return text;

  const textContainsVariablesToPopulate = /\{.+?\}/g;
  if (!textContainsVariablesToPopulate.test(text)) return text;

  let parsedText = text;

  Object.entries(variables).forEach(([key, value]) => {
    parsedText = parsedText.replace(new RegExp(`\\{${key}\\}`, 'g'), value);
  });
  return parsedText;
};

const convertURLRecordToSeoMetadata = (
  urlRecord: Record<string, any>,
  metadataOptions: MetaDataOptions
): Record<string, any> => {
  const { keywords, ...nerdLayoutProps } =
    metadataOptions.nerdLayoutMappings || {};
  const { variables, url } = metadataOptions;

  const parsedUrl =
    typeof url === 'function' ? url(urlRecord?.url) : urlRecord?.url;
  const title = populateVariables(urlRecord?.title, variables);
  const seoTitle = populateVariables(urlRecord?.seo?.title, variables);
  const seoDescription = populateVariables(
    urlRecord?.seo?.description,
    variables
  );
  const seoKeyword = populateVariables(urlRecord?.seo?.keyword, variables);
  const seoTwitterTitle = populateVariables(
    urlRecord?.seo?.twitter?.title,
    variables
  );
  const seoTwitterDescription = populateVariables(
    urlRecord?.seo?.twitter?.description,
    variables
  );

  return {
    ...nerdLayoutProps,
    title: seoTitle || title,
    description: seoDescription,
    keywords: seoKeyword || keywords,
    ogTags: {
      canonicalURL: parsedUrl,
      description: seoDescription,
      image:
        urlRecord?.featuredMedia?.croppedImage?.sourceUrl ||
        urlRecord?.featuredMedia?.sourceUrl,
      'image:secure_url':
        urlRecord?.featuredMedia?.croppedImage?.sourceUrl ||
        urlRecord?.featuredMedia?.sourceUrl,
      locale: 'en_US',
      type: metadataOptions.imageType,
      url: parsedUrl,
      site_name: 'NerdWallet',
    },
    dynamicMeta: [
      {
        name: 'article:publisher',
        content: 'http://www.facebook.com/NerdWallet',
      },
      { name: 'article:section', content: 'Brokers' },
      { name: 'twitter:card', content: 'summary_large_image' },
      {
        name: 'twitter:title',
        content: seoTwitterTitle || seoTitle || title,
      },
      {
        name: 'twitter:description',
        content: seoTwitterDescription || seoDescription,
      },
      { name: 'twitter:site', content: '@NerdWallet' },
      {
        name: 'twitter:image',
        content:
          urlRecord?.featuredMedia?.croppedImage?.sourceUrl ||
          urlRecord?.featuredMedia?.sourceUrl,
      },
      {
        name: 'twitter:creator',
        content: `@ ${urlRecord?.authors?.[0]?.twitter || 'NerdWallet'}`,
      },
      { name: 'article:published_time', content: urlRecord?.date },
      { name: 'article:modified_time', content: urlRecord?.modified },
      { name: 'og:updated_time', content: urlRecord?.modified },
    ],
  };
};

export default convertURLRecordToSeoMetadata;
